import { render, staticRenderFns } from "./MembersDisplay.vue?vue&type=template&id=2a110047"
import script from "./MembersDisplay.vue?vue&type=script&lang=js"
export * from "./MembersDisplay.vue?vue&type=script&lang=js"
import style0 from "./MembersDisplay.vue?vue&type=style&index=0&id=2a110047&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports